module.exports = __webpack_public_path__ + "img/zoiper.a392c3fc.png";